import React from "react";
import profileImg from "../assets/images/ProfilePic.jpg";
import { FaTwitter, FaLinkedin, FaMedium, FaGithub, FaAngellist } from "react-icons/fa";

const Hero = () => {
  return (
    <section className="bg-gray-900 text-gray-100 py-20 min-h-screen" id="hero">
      <div className="container max-w-6xl pt-10 mx-auto max-w-6xl flex flex-col lg:flex-row items-center justify-center">
        <div className="lg:w-1/3 mb-10 lg:mb-0">
          <img src={profileImg} alt="Profile" className="rounded-full w-48 h-48 sm:w-64 sm:h-64 lg:w-64 lg:h-64" />
        </div>
        <div className="text-center lg:text-left lg:w-2/3">
          <h2 className="text-3xl font-bold mb-4" style={{ color: "rgb(92, 225, 230)" }}>Hi, I'm Abraha Kahsay</h2>
          <p className="mb-6 text-center lg:text-left max-w-lg mx-auto lg:mx-0">
            I'm a software developer and Thermal Engineer {"(MSc)"} with experience in building web and mobile applications. I'm passionate about using technology to solve problems and create new possibilities.
          </p>
          <p className="mb-4" style={{ color: "rgb(92, 225, 230)" }}>
            Let's connect! You can find me on:
          </p>
          <div className="flex justify-center lg:justify-start">
            <a href="https://twitter.com/abraha_ka" target="_blank" rel="noopener noreferrer" className="mx-4 hover:text-gray-300">
              <FaTwitter className="h-6 w-6" />
            </a>
            <a href="https://www.linkedin.com/in/abraha-kahsay" target="_blank" rel="noopener noreferrer" className="mx-4 hover:text-gray-300">
              <FaLinkedin className="h-6 w-6" />
            </a>
            <a href="https://medium.com/@abrahakahsay" target="_blank" rel="noopener noreferrer" className="mx-4 hover:text-gray-300">
              <FaMedium className="h-6 w-6" />
            </a>
            <a href="https://github.com/AbrahaKahsay" target="_blank" rel="noopener noreferrer" className="mx-4 hover:text-gray-300">
              <FaGithub className="h-6 w-6" />
            </a>
            <a href="https://wellfound.com/u/abrahakahsay" target="_blank" rel="noopener noreferrer" className="mx-4 hover:text-gray-300">
              <FaAngellist className="h-6 w-6" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
